<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <el-breadcrumb-item>流程管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="handleNew"
        v-permission="Auth.flowNew"
        >新增流程</el-button
      >
      <el-table :data="lists" stripe style="width: 100%">
        <el-table-column prop="name" label="名称" min-width="300">
          <template slot-scope="scope">
            <div>
              {{ scope.row.name
              }}<el-tag size="mini" class="ml-5">{{
                FlowCategoryMap[scope.row.category]
              }}</el-tag>
            </div>
            <div>{{ scope.row.description }}</div>
            <el-breadcrumb
              separator-class="el-icon-arrow-right"
              style="border: none; padding: 0"
            >
              <el-breadcrumb-item
                style="font-size: 14px"
                v-for="(item, index) in scope.row.approver_names"
                :key="index"
                >{{ item }}</el-breadcrumb-item
              >
            </el-breadcrumb>
          </template>
        </el-table-column>
        <el-table-column label="条件" width="220">
          <template slot-scope="scope">
            <template v-if="scope.row.category == 1 || scope.row.category == 2">
              <template v-if="scope.row.category == 2">
                中间商等级：{{ DealerRanks[scope.row.dealer_rank] }}
                <br />
              </template>
              折扣：{{ scope.row.discount_start / 10 }}折 -
              {{ scope.row.discount_end / 10 }}折
              <!-- <template v-if="scope.row.category == 1">
                <br />
                利润率：{{ scope.row.profit_margin_start }}% -
                {{ scope.row.profit_margin_end }}%
              </template> -->
            </template>
            <template v-else>无</template>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="description" label="描述"></el-table-column> -->
        <el-table-column align="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-popconfirm
              :title="'确认删除吗？'"
              @confirm="handleDelete(scope.$index, scope.row.id)"
              v-permission="Auth.flowDelete"
            >
              <el-button slot="reference" type="danger" plain size="mini"
                >删除</el-button
              >
            </el-popconfirm>
            <el-button
              type="primary"
              plain
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
              v-permission="Auth.flowEdit"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        :title="flow.id ? '编辑流程' : '新增流程'"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="40%"
        @closed="resetForm('flow')"
      >
        <el-form
          :model="flow"
          :rules="rules"
          ref="flow"
          size="small"
          label-width="100px"
        >
          <el-form-item label="名称" prop="name">
            <el-input v-model="flow.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="业务模块" prop="category">
            <el-select
              v-model="flow.category"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(value, name) in FlowCategoryMap"
                :key="name"
                :label="value"
                :value="parseInt(name)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input
              v-model="flow.description"
              type="textarea"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="中间商等级"
            class="item-slider"
            v-if="flow.category == 2"
          >
            <el-select v-model="flow.dealer_rank" placeholder="请选择">
              <el-option
                v-for="(value, name) in DealerRanks"
                :key="name"
                :label="value"
                :value="parseInt(name)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="条件(折扣)"
            class="item-slider"
            v-if="flow.category == 1 || flow.category == 2"
          >
            <el-slider
              v-model="flow.discount"
              range
              :max="100"
              :step="1"
              :marks="discountMarks"
              :show-tooltip="false"
            ></el-slider>
          </el-form-item>
          <!-- <el-form-item
            label="条件(利润率)"
            class="item-slider"
            v-if="flow.category == 1"
          >
            <el-slider
              v-model="flow.profit_margin"
              range
              :max="100"
              :marks="profitMarginMarks"
              :show-tooltip="false"
            ></el-slider>
          </el-form-item> -->
          <!-- <el-form-item label="条件(折扣)">
            <div class="el-col el-col-11">
              <el-input-number
                v-model="flow.discount_start"
                :min="0"
                :max="9"
                :step="1"
                step-strictly
                autocomplete="off"
                placeholder="请填写"
                type="number"
              ></el-input-number>
            </div>
            <div class="line el-col el-col-2 text-center">-</div>
            <div class="el-col el-col-11">
              <el-input-number
                v-model="flow.discount_end"
                :min="0"
                :max="9"
                :step="1"
                step-strictly
                autocomplete="off"
                placeholder="请填写"
                type="number"
              ></el-input-number>
            </div>
          </el-form-item>
          <el-form-item label="条件(利润率%)">
            <div class="el-col el-col-11">
              <el-input-number
                v-model="flow.profit_margin_start"
                :step="1"
                step-strictly
                autocomplete="off"
                placeholder="请填写"
                type="number"
              ></el-input-number>
            </div>
            <div class="line el-col el-col-2 text-center">-</div>
            <div class="el-col el-col-11">
              <el-input-number
                v-model="flow.profit_margin_end"
                :step="1"
                step-strictly
                autocomplete="off"
                placeholder="请填写"
                type="number"
              ></el-input-number>
            </div>
          </el-form-item>-->
          <div>
            <el-form-item
              v-for="(approver, index) in flow.approvers"
              :class="{ 'mb-10': index < flow.approvers.length - 1 }"
              :label="index == 0 ? '审批角色' : ''"
              :key="index"
              :prop="'approvers.' + index + '.value'"
              :rules="{
                required: true,
                message: '审批角色不能为空',
                trigger: 'change',
              }"
            >
              <el-select v-model="approver.value">
                <el-option
                  v-for="item in roles"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <i class="el-icon-bottom"></i>
              <el-button @click.prevent="removeApprover(index)" v-if="index > 0"
                >删除</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button @click="addApprover" type="primary"
                >添加审批人</el-button
              >
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="small"
            >取 消</el-button
          >
          <el-button type="primary" @click="submitForm('flow')" size="small"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  userList,
  flowList,
  createFlow,
  updateFlow,
  deleteFlow,
  roleList,
} from '@/service/getData'
import { clone } from '@/util'
import { FlowCategoryMap, DealerRanks } from '@/config/global.js'
import auth from '@/util/auth'

export default {
  data() {
    return {
      auth,
      FlowCategoryMap,
      DealerRanks,
      page: 0,
      size: 20,
      users: [],
      roles: [],
      flow: {},
      editIndex: 0,
      rules: {
        name: [
          { required: true, message: '请填写流程名称', trigger: 'blur' },
          {
            min: 2,
            max: 15,
            message: '长度在 2 到 15 个字符',
            trigger: 'blur',
          },
        ],
        category: [
          { required: true, message: '请选择业务模块', trigger: 'blur' },
        ],
      },
      lists: [],
      dialogVisible: false,
    }
  },
  computed: {
    discountMarks() {
      let marks = {}
      if (this.flow.discount) {
        let start = this.flow.discount[0]
        let end = this.flow.discount[1]
        marks[start] = `${start / 10}折`
        marks[end] = `${end / 10}折`
      }
      return marks
    },
    profitMarginMarks() {
      let marks = {}
      if (this.flow.profit_margin) {
        let start = this.flow.profit_margin[0]
        let end = this.flow.profit_margin[1]
        marks[start] = `${start}%`
        marks[end] = `${end}%`
      }
      return marks
    },
  },
  created() {
    this.initData()
    this.getRoles()
    if (!this.auth.isPlatformUser()) {
      let newMap = {}
      for (const key in this.FlowCategoryMap) {
        if (key != 2) {
          newMap[key] = this.FlowCategoryMap[key]
        }
      }
      this.FlowCategoryMap = newMap
    }
  },
  methods: {
    async getRoles() {
      let res = await roleList()
      if (res.code == 0) {
        this.roles = res.data.list.filter((item) => item.name != '超级管理员')
      }
    },
    async initData() {
      let res = await flowList({
        page: this.page,
        size: this.size,
      })
      if (res.code == 0) {
        this.lists = res.data.list
      }

      res = await userList({ page: 0, size: 1000 })
      if (res.code == 0) {
        res.data.list.unshift({ id: 0, name: '组长' })
        this.users = res.data.list
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let data = clone(this.flow)
          let approvers = []
          let approver_names = []
          data.approvers.map((item) => {
            approvers.push(item.value)
            let name =
              this.roles.filter((role) => item.value == role.id)[0].name || ''
            approver_names.push(name)
          })

          data.approvers = approvers
          data.approver_names = approver_names
          data.discount_start = data.discount[0]
          data.discount_end = data.discount[1]
          data.profit_margin_start = data.profit_margin[0]
          data.profit_margin_end = data.profit_margin[1]

          if (this.flow.id) {
            let res = await updateFlow(data)
            if (res.code == 0) {
              this.$set(this.lists, this.editIndex, res.data)
              this.dialogVisible = false
            }
          } else {
            let res = await createFlow(data)
            if (res.code == 0) {
              this.lists.unshift(res.data)
              this.dialogVisible = false
            }
          }
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.flow.id = 0
    },
    addApprover() {
      this.flow.approvers.push({
        value: '',
      })
    },
    removeApprover(index) {
      this.flow.approvers.splice(index, 1)
    },
    handleNew() {
      this.flow = {
        id: 0,
        approvers: [{ value: '' }],
        name: '',
        discount: [0, 0],
        profit_margin: [0, 0],
        description: '',
        category: '',
        dealer_rank: 0,
      }
      this.dialogVisible = true
    },
    handleEdit(index, item) {
      this.dialogVisible = true
      this.editIndex = index
      this.$nextTick(() => {
        let data = clone(item)
        let approversArray = eval(data.approvers) || ['']
        data.approvers = approversArray.map((item) => {
          return { value: item }
        })
        data.discount = [data.discount_start, data.discount_end]
        data.profit_margin = [data.profit_margin_start, data.profit_margin_end]
        this.flow = data
      })
    },
    async handleDelete(index, id) {
      let res = await deleteFlow(id)
      if (res.code == 0) {
        this.lists.splice(index, 1)
      }
    },
  },
}
</script>

<style>
.item-slider .el-slider__marks-text:nth-last-child(1) {
  word-break: keep-all;
}
.item-slider .el-slider__runway {
  margin: 14px 0;
}
</style>

<style scoped>
.el-form-item.item-slider {
  margin-bottom: 30px !important;
}
.el-input-number--small {
  width: 100%;
}
.long {
  width: 100%;
}
</style>